import { z } from 'zod';

/**
 * Enum de `expresion_vr` (JC §3.1; rediseñado por el core el 2026-08-26).
 * El servidor garantiza pertenencia: normaliza cualquier salida
 * inesperada de la IA a `NEUTRAL` antes de emitir. Detalle de cada valor
 * en `docs/03_EXPRESIONES.md`.
 *
 * Nomenclatura: en el **wire** el campo es `ia.expresion_vr` (legado
 * Unity VR). Tras el remapeo del borde en `@alter/api-client`, el resto
 * del cliente lo ve como `expresion_avatar`. Los valores son los mismos.
 */
export const EXPRESIONES_AVATAR = [
  'ALEGRIA',
  'AVERSION',
  'DOLOR',
  'ENOJO',
  'ESPERANZA',
  'MIEDO',
  'NEUTRAL',
  'PREOCUPACION',
  'SORPRESA',
  'TRISTEZA',
] as const;

/** Union literal de las 10 expresiones del contrato. */
export type ExpresionAvatar = (typeof EXPRESIONES_AVATAR)[number];

/**
 * Predicado de narrowing: `true` si `value` está en `EXPRESIONES_AVATAR`.
 * Defensa en profundidad (P3): aunque el servidor garantiza pertenencia,
 * el motor cae a `NEUTRAL` ante un valor desconocido.
 */
export function isExpresionAvatar(value: string): value is ExpresionAvatar {
  return (EXPRESIONES_AVATAR as readonly string[]).includes(value);
}

/**
 * Schema laxo de `ia.expresion_vr`: `z.string()` a propósito (P3, D-5).
 * Narrow con `isExpresionAvatar` tras el remapeo.
 */
export const ExpresionVRLaxoSchema = z.string();
